import { DataTableColumn } from "../../../shared/components/data-table/DataTableColumn.model";
import { Currency } from "../../currencies/models/Currency";
import { CurrenciesService } from "../../currencies/services/currencies.service";

export interface NightlyPrice {
    id: number,
    policy_price_id: number,
    name: string,
    number_of_nights_from: number,
    number_of_nights_to: number,
    price: number,
    account_id: number,
    created_date: Date,
    updated_date: Date,
    is_active: boolean;
}


export const NightlyPricesColumns: DataTableColumn[] = [
    { column: 'numNightsFrom', display: 'NO. OF NIGHTS FROM' },
    { column: 'numNightsTo', display: 'NO. OF NIGHTS TO' },
    { column: 'name', display: 'NAME' },
    { column: 'price', display: 'PRICE' }
]

export interface NightlyPriceRow {
    numNightsFrom: number;
    numNightsTo: number;
    name: string;
    price: string | number | null;
}

export const getPriceRowFromPrice = (price: NightlyPrice, currency: Currency, currenciesService: CurrenciesService): NightlyPriceRow => {
    return {
        numNightsFrom: price.number_of_nights_from,
        numNightsTo: price.number_of_nights_to,
        name: price.name,
        price: currenciesService.prependCurrencySymbol(currency, `${price.price}`),
    }
}